import { DocumentNode, gql } from "@apollo/client";

class TokenizedLinksService {
  public static getResourceFromToken = (): DocumentNode => gql`
    query GetResourceFromToken($token: String!) {
      getResourceFromToken(token: $token) {
        action
        data {
          ... on ActivateUser {
            email
          }
          ... on TokenizedLinkTestDataPublic {
            orderUidPublic
            testType
            testUid
          }
          ... on ResetPasswordData {
            email
          }
          ... on UpdateEmailData {
            email
          }
        }
        sourceData {
          source
        }
      }
    }
  `;

  public static getResourceFromUPSToken = (): DocumentNode => gql`
    query GetResourceFromUPSToken($token: String!) {
      getResourceFromUPSToken(token: $token) {
        action
        sourceData {
          source
        }
      }
    }
  `;

  public static getTokenSource = (): DocumentNode => gql`
    query GetTokenSource($token: String!, $intentToken: String) {
      getTokenSource(token: $token, intentToken: $intentToken) {
        source
        language
        notificationType
      }
    }
  `;

  public static getLanguageByToken = (): DocumentNode => gql`
    query GetLanguageByToken($token: String!) {
      getLanguageByToken(token: $token) {
        language
      }
    }
  `;

  public static getUserEmailByToken = (): DocumentNode => gql`
    query GetUserEmailByToken($token: String!, $intentToken: String) {
      getUserEmailByToken(token: $token, intentToken: $intentToken) {
        email
      }
    }
  `;

  public static checkUserExistsByToken = (): DocumentNode => gql`
    query CheckUserExistsByToken($token: String!) {
      checkUserExistByToken(token: $token) {
        isExist
      }
    }
  `;

  public static getOrderUidPublicFromToken = (): DocumentNode => gql`
    query GetOrderUidPublicFromToken($token: String!) {
      getOrderUidPublicFromToken(token: $token) {
        action
        orderUidPublic
        sourceData {
          source
          language
          notificationType
        }
      }
    }
  `;

  public static getGeneratedTokenizedLink = (): DocumentNode => gql`
    query GetGeneratedTokenizedLink(
      $generatedTokenizedLink: GeneratedTokenizedLink!
    ) {
      getGeneratedTokenizedLink(
        generatedTokenizedLink: $generatedTokenizedLink
      ) {
        link
      }
    }
  `;

  /**
   * Generated token either belongs to ups or post-bill app.
   */
  public static getPatientUidFromToken = (): DocumentNode => gql`
    query GetPatientUidFromToken($token: String!) {
      getPatientUidFromToken(token: $token) {
        patientUid
      }
    }
  `;
}

export default TokenizedLinksService;
